import { render, staticRenderFns } from "./ChannelAddRemoveUser.vue?vue&type=template&id=7ccbbfc8&scoped=true&"
import script from "./ChannelAddRemoveUser.vue?vue&type=script&lang=js&"
export * from "./ChannelAddRemoveUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccbbfc8",
  null
  
)

export default component.exports